import { render, staticRenderFns } from "./MsOrganizationUnit.vue?vue&type=template&id=5ecf3c92&scoped=true"
import script from "./MsOrganizationUnit.vue?vue&type=script&lang=js"
export * from "./MsOrganizationUnit.vue?vue&type=script&lang=js"
import style0 from "./MsOrganizationUnit.vue?vue&type=style&index=0&id=5ecf3c92&prod&lang=scss&scoped=true"
import style1 from "./MsOrganizationUnit.vue?vue&type=style&index=1&id=5ecf3c92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecf3c92",
  null
  
)

export default component.exports